const ConnectFunction = 'ConnectFunction';

module.exports = { ConnectFunction };
